export default __webpack_public_path__ + "static/media/KOD0148-min.ed5d56a1.webp";